import { render, staticRenderFns } from "./ForbiddenContentRoot.vue?vue&type=template&id=fd8f07da"
import script from "./ForbiddenContentRoot.vue?vue&type=script&lang=ts"
export * from "./ForbiddenContentRoot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports